import { render } from "./ForeignTradeByRegions.vue?vue&type=template&id=604dcd64&ts=true"
import script from "./ForeignTradeByRegions.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByRegions.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__